module.exports = __webpack_public_path__ + "static/media/waves.f116a594.svg";